import { IconCopy } from '@components/icons/icon-copy';
import { IconSend } from '@components/icons/icon-send';
import { TFunction } from 'i18next';

import { OPTION_SEND_LINK } from '../process-invite-guest/process-invite-guest.type';

export const SendButtonText = ({
  watchedSelectedOption,
  email,
  t,
  compact,
}: {
  watchedSelectedOption: string;
  email?: string;
  t: TFunction;
  compact?: boolean;
}) => {
  const showSendLinkButton = watchedSelectedOption === OPTION_SEND_LINK && !email;
  const showCopyLinkButton = watchedSelectedOption === OPTION_SEND_LINK && email;
  if (showCopyLinkButton)
    return (
      <>
        <IconCopy className='w-4 h-4' /> {compact ? t('common:copy') : t('invitations:copyLink')}
      </>
    );
  if (showSendLinkButton)
    return (
      <>
        <IconSend className='w-4 h-4' /> {compact ? t('common:send') : t('invitations:sendLink')}
      </>
    );

  return (
    <>
      <IconSend className='w-4 h-4' /> {compact ? t('common:send') : t('invitations:sendInvite')}
    </>
  );
};
